import { language as lan_detailBreadcrumb } from "./breadcrumb";
import { language as lan_detailAddToCart } from "./add-to-cart";
import { language as lan_detailPrice } from "./price";
import { language as lan_detailStartDesign } from "./strat-design";
import { language as lan_detailRest } from "./detail-rest";
import { language as lan_detailSpecification } from "./specification";
import { language as lan_detailShipping } from "./shipping";
import { language as lan_detailSnapShop } from "./snap-shop";
import { language as lan_detailApiIntegration } from "./api-integration";
import { language as lan_detailRecommend } from "./recommend";
import { language as lan_designModel } from "./design-model"; 

let language = {
    ...lan_detailBreadcrumb,
    ...lan_detailAddToCart,
    ...lan_detailPrice,
    ...lan_detailStartDesign,
    ...lan_detailRest,
    ...lan_detailSpecification,
    ...lan_detailShipping,
    ...lan_detailSnapShop,
    ...lan_detailApiIntegration,
    ...lan_detailRecommend,
    ...lan_designModel,
    // 产品类型暂暂不支持-进行产品定制
    PRODUCT_DETAIL_INVALID_ORDER_A_SAMPLE_TITLE: "无效订购样品",
    PRODUCT_DETAIL_INVALID_ORDER_A_SAMPLE_CONTENT: "您尝试打开定制页面时发生错误，请稍后重试",
    PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE: "产品运费计价异常",
    PRODUCT_DETAIL_SHIPPING_ERROR_TITLE: "产品运费加载错误",
    PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE_CONTENT1: "问题出现在产品运费计算过程中，请您点击 \"{{retryBtn}}\" 重新计算产品运费, 如果问题仍然存在，请随时联系我们的支持团队{{supportmail}}。",
    PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE_CONTENT2: "计算运费时出错。请刷新页面并重试。如果问题仍然存在，请通过 {{supportmail}} 联系我们。",
    PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE_CONTENT3: "计算运费时产品属性出现问题。请刷新页面并重试。如果问题仍然存在，请通过 {{supportmail}} 联系我们。",
    PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE_CONTENT4: "计算运费时产品重量出现问题。请刷新页面并重试。如果问题仍然存在，请通过 {{supportmail}} 联系我们。",
    PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE_CONTENT5: "计算运费时，运费 API 出现问题。请刷新页面并重试。如果问题仍然存在，请通过 {{supportmail}} 联系我们。",
    PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE_CONTENT6: "计算运费时，运输天数出现问题。请刷新页面并重试。如果问题仍然存在，请通过 {{supportmail}} 联系我们。",
    PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE_CONTENT7: "计算运费时出错。请刷新页面并重试。如果问题仍然存在，请通过 {{supportmail}} 联系我们。",
    PRODUCT_DETAIL_SHIPPING_CUSTOM_QTY_MIN_TIP: "产品最小数量为{{minQty}}。",
    PRODUCT_DETAIL_SHIPPING_CUSTOM_QTY_MAX_TIP: "产品最大数量为{{maxQty}}。",
    PRODUCT_DETAIL_SHIPPING_PRRICE_NULL_TIP: "此运输方式不适用于所选的产品数量。",
    PRODUCT_DETAIL_SHIPPING_EXPORT_ISSUE_TITLE: "产品运费导出异常",
    PRODUCT_DETAIL_SHIPPING_EXPORT_ERROE_TITLE: "产品运费导出错误",
    PRODUCT_DETAIL_SHIPPING_EXPORT_ISSUE_CONTENT1: "问题出现在产品运费导出过程中，请您稍后重试, 如果问题仍然存在，请随时联系我们的支持团队{{supportmail}}。",
    PRODUCT_DETAIL_PRICE_ISSUE_TITLE: "产品格表异常",
    PRODUCT_DETAIL_PRICE_ISSUE_CONTENT: "查询产品数量价格表时发生错误。 请刷新页面再试一次。 如果问题仍然存在，请联系我们 {{supportmail}}.",
    PRODUCT_DETAIL_PRICE_ERROE_TITLE: "产品价格表错误",
    PRODUCT_DETAIL_CURRENCY_CONFIG_MISSING: "{{appName}}货币设置错误。 请刷新页面并点击\“{{updateCurrencyBtn}}\”更新{{appName}}显示货币。 如果问题仍然存在，请联系{{serviceEmail}}。",
    PRODUCT_DETAIL_CURRENCY_NONSUPPORT: "不支持您选择的货币。 请按\“{{updateCurrencyBtn}}\”更新{{appName}}显示货币。",
    PRODUCT_DETAIL_PROPERTY_FORM_VALIDATE_ISSUE: "属性表单错误",
    PRODUCT_DETAIL_PROPERTY_FORM_VALIDATE_ISSUE_CONTENT: "属性表单错误,请稍后重试,如果问题仍然存在，请联系我们 {{supportmail}}",
    PRODUCT_DETAIL_DESIGN_METHOD_ISSUE_TITLE:"产品设计模式异常",
    PRODUCT_DETAIL_DESIGN_METHOD_ISSUE_CONTENT:"在更新产品设计方法时发生错误，请您稍后重新尝试。如问题仍未解决，请联系我们的技术支持团队，邮箱 {{supportmail}}。"

}

export { language }